import styled, { css } from 'styled-components';
import { stylePerBreakpoint } from '../../helpers/mediaQuery';

export const OverflowContainer = styled.div`
  width: 100%;
`;

/**
 * The container for a page where the fluid grid is used. Handles the container width, as specified
 * in the theme.
 */
export const MaxWidthAndSpacingContainer = styled.div`
  margin: 0 auto;

  ${stylePerBreakpoint(
    (breakpoint) => css`
      max-width: ${({ theme }) => {
        const breakpointContainerWidth = theme.layout[breakpoint].containerWidthPx;
        return breakpointContainerWidth
          ? `${breakpointContainerWidth + 2 * theme.layout[breakpoint].gutterPx}px`
          : 'none';
      }};
      padding: 0 ${({ theme }) => theme.layout[breakpoint].gutterPx}px;
    `
  )}
`;
